module.exports = __webpack_public_path__ + "img/pro_one_6.6d9e477e.jpg";